import { useTranslation } from 'react-i18next'
import { useImpersonateAvailable } from '../hooks/UseImpersonateAvailable'
import { ImpersonateSelect } from './ImpersonateSelect'

/** Выбор пользователя для входа под ним: только админам и в режиме имперсонации */
export const ImpersonateBar = () => {
  const { t } = useTranslation()
  const isAvailable = useImpersonateAvailable()

  if (!isAvailable) return null

  return (
    <div className={'mx-auto px-[16px] md:container xl:max-w-[1440px] xxl:max-w-[1920px]'}>
      <div className={'flex items-center gap-[4px] py-[6px]'}>
        <p className={'text-white'}>{t('notifications.impersonatedAs')}</p>
        <ImpersonateSelect />
      </div>
    </div>
  )
}
